import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { pluck } from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';
import { IDocumentResult } from '../../state/interfaces';
import { AsyncPipe } from '@angular/common';
import { MatCard } from '@angular/material/card';
import { MatProgressBar } from '@angular/material/progress-bar';
import { ResultsListComponent } from '../results-list/results-list.component';
import { AlertBoxComponent } from '../shared/alert-box/alert-box.component';

export interface ISessionStatus {
  total: number;
  completed: number;
}

@Component({
  selector: 'eca-scan-session-review',
  templateUrl: './scan-session-review.component.html',
  styleUrls: ['./scan-session-review.component.css'],
  imports: [MatCard, MatProgressBar, ResultsListComponent, AlertBoxComponent, AsyncPipe]
})

export class ScanSessionReviewComponent {
  private _store = inject<Store<any>>(Store);


  poll$: Observable<any>;
  pollScansSub: Subscription;
  pollDocumentsSub: Subscription;
  statusSub: Subscription;

  sessionId$: Observable<string>;
  errors$: Observable<string[]>;
  successful$: Observable<IDocumentResult[]>;
  failures$: Observable<IDocumentResult[]>;
  processing$: Observable<IDocumentResult[]>;

  hasFailedDocuments$: Observable<boolean>;
  hasSuccessfulDocuments$: Observable<boolean>;
  isPolling$: Observable<boolean>;
  scansCompleted$: Observable<boolean>;

  totalScans$: Observable<number>;
  completedScans$: Observable<number>;

  constructor() {
    this.sessionId$ = this._store.select('session').pipe(pluck('id'));
    this.isPolling$ = this._store.select('polling');
    this.scansCompleted$ = this._store.select('scans').pipe(pluck('completed'));

    this.successful$ = this._store.select('results').pipe(pluck('successful'));
    this.failures$ = this._store.select('results').pipe(pluck('failures'));
    this.processing$ = this._store.select('results').pipe(pluck('processing'));
    this.hasFailedDocuments$ = this._store.select('results').pipe(pluck('hasFailures'));
    this.hasSuccessfulDocuments$ = this._store.select('results').pipe(pluck('hasSuccessful'));
    this.errors$ = this._store.select('results').pipe(pluck('errors'));
    this.totalScans$ = this._store.select('scans').pipe(pluck('totalScans'));
    this.completedScans$ = this._store.select('scans').pipe(pluck('completedScans'));
  }

}
